import React from 'react';
import styled from 'styled-components';

import { theme } from '../../styles/theme';

interface SideSelectorProps {
  value: 'left' | 'right';
  onChange: (value: 'left' | 'right') => void;
  disabled?: boolean;
}

const SelectorContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.75rem;
`;

const OptionButton = styled.button<{ $active: boolean }>`
  flex: 1;
  border-radius: ${theme.borderRadius.lg};
  border: 1px solid ${({ $active }) => ($active ? theme.colors.primary[500] : theme.colors.border.light)};
  background: ${({ $active }) => ($active ? theme.colors.primary[50] : 'white')};
  color: ${({ $active }) => ($active ? theme.colors.primary[600] : theme.colors.text.secondary)};
  padding: 0.6rem 0.75rem;
  font-size: ${theme.typography.fontSize.sm};
  font-weight: ${theme.typography.fontWeight.medium};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${theme.colors.primary[400]};
    color: ${theme.colors.primary[500]};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const SideSelector: React.FC<SideSelectorProps> = ({ value, onChange, disabled }) => {
  return (
    <SelectorContainer role="group" aria-label="Select side angle">
      <OptionButton
        type="button"
        $active={value === 'left'}
        onClick={() => onChange('left')}
        disabled={disabled}
      >
        Left side
      </OptionButton>
      <OptionButton
        type="button"
        $active={value === 'right'}
        onClick={() => onChange('right')}
        disabled={disabled}
      >
        Right side
      </OptionButton>
    </SelectorContainer>
  );
};


